import { getRandomFromArr, isNotUndefined } from "../utils/dictionaries";
import { CharacterHandler, CharacterState, StatusType } from "./characters";
import { isDmgStatus, StatusHandler } from "./status";
import { WorldState, WorldPos, WorldHandler } from "./world";
import config from "../worldConfig";

const { HUNGER_DMG_MOVE_TRIGGER } = config;
const getMoveTarget = (w: WorldState, c: CharacterState): WorldPos => {
  const moveDirection = [
    {
      target: { x: c.pos.x, y: c.pos.y - 1 },
      isReachable: c.pos.y > 0,
    },
    {
      target: { x: c.pos.x + 1, y: c.pos.y },
      isReachable: c.pos.x < w.size - 1,
    },
    {
      target: { x: c.pos.x, y: c.pos.y + 1 },
      isReachable: c.pos.y < w.size - 1,
    },
    {
      target: { x: c.pos.x - 1, y: c.pos.y },
      isReachable: c.pos.x > 0,
    },
  ];
  return getRandomFromArr(moveDirection.filter((d) => d.isReachable)).target;
};

export const doMove = (w: WorldState): WorldState => {
  //@TODO: changing POS faction should not make character loose all influence on others
  const newWorld = WorldHandler.updateFactionPos({
    ...w,
    characters: w.characters.map((c) => {
      const hungryStatus = StatusHandler.findStatus(
        StatusType.STARVING,
        c.statusList
      );

      //@TODO: ADD check if in a war => either war + stay on place or NO war and moving

      const isHungry =
        isNotUndefined(hungryStatus) && isDmgStatus(hungryStatus);

      if (isHungry) {
        if (
          hungryStatus.payload.dmg >
          CharacterHandler.hpMax(c) * HUNGER_DMG_MOVE_TRIGGER
        ) {
          const newPos = getMoveTarget(w, c);
          return {
            ...c,
            pos: newPos,
          };
        }
      }

      return c;
    }),
  });

  return newWorld;
};
